// import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Alert, AlertDescription, AlertTitle } from "../ui";
import { cn } from "@/lib/utils";
import { CheckCircle2, XCircle } from "lucide-react";

const createToast = (message, type = "success") => {
  const Toast = ({ message, type }) => {
    const isSuccess = type === "success";

    return (
      <Alert
        className={cn(
          "fixed top-4 right-4 w-auto max-w-md animate-in fade-in-0 zoom-in-95 duration-300",
          isSuccess
            ? "bg-green-50 border-green-200"
            : "bg-red-50 border-red-200"
        )}
      >
        {isSuccess ? (
          <CheckCircle2 className="h-4 w-4 text-green-600" />
        ) : (
          <XCircle className="h-4 w-4 text-red-600" />
        )}
        <AlertTitle className={isSuccess ? "text-green-800" : "text-red-800"}>
          {isSuccess ? "Éxito" : "Error"}
        </AlertTitle>
        <AlertDescription
          className={isSuccess ? "text-green-600" : "text-red-600"}
        >
          {message}
        </AlertDescription>
      </Alert>
    );
  };

  return Toast;
};

export { createToast };
